import {Spell} from "@/spells/model/Spell.ts";
import {displaySpellSchool} from "@/spells/SpellFormatting.ts";
import {getSchoolAttributes} from "@/spells/model/SpellSchools.ts";
import DetailTitleBlock from "@/components/details/DetailTitleBlock.tsx";
import {cn} from "@/lib/utils.ts";

export default function SpellDetailsHeader({spell}: { spell: Spell }) {
    const school = getSchoolAttributes(spell);

    return (
        <header className={cn(
            "grid gap-x-10 border-b px-4 @min-[40rem]:grid-cols-[minmax(12rem,max-content)_minmax(0,1fr)]",
            school.border,
            school.bg,
        )}>
            <DetailTitleBlock title={spell.name}/>

            <div className="flex flex-row justify-between items-end py-1 text-base text-muted-foreground">
                <div className="font-semibold" style={{fontVariant: "small-caps"}}>{displaySpellSchool(spell)}</div>
                {spell.classes.length > 0 &&
                    <div className="min-w-0"><span
                        className="font-semibold">Klassen:</span><span> {spell.classes.join(" · ")}</span></div>}

            </div>
        </header>
    );
}
